import axios from "axios";
import { DiagramType } from "../interfaces/snp.interface";

export const getAnalytics = (type: DiagramType, kato: number): Promise<any[]> => {
  const analyticsType = ['harvest', 'lifestock'].includes(type.toLowerCase()) ? `AGRICULTURE_${type.toUpperCase()}` : type.toUpperCase();

  return axios.get(`/api/public/analytics/${kato}?type=${analyticsType.replaceAll('-', '_')}`).then((res) => res.data.list);
};